import { render } from "./BaseSpinner.vue?vue&type=template&id=2389dacc&scoped=true"
const script = {}

import "./BaseSpinner.vue?vue&type=style&index=0&id=2389dacc&scoped=true&lang=css"

import exportComponent from "/home/hiba/project03-vue.js-find-a-coach/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2389dacc"]])

export default __exports__